import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

// Custom hook
const CommanForm = ({ validationSchema, defaultValues }: any) => {
    const { register, watch, setValue, formState: { errors }, handleSubmit, reset, trigger, setError, clearErrors, control,getValues } = useForm({
        mode: 'onChange',
        resolver: yupResolver(validationSchema),
        defaultValues
    });

    return {
        register,
        watch,
        setValue,
        errors,
        handleSubmit,
        reset,
        trigger,
        setError,
        clearErrors,
        control,
        getValues
    };
};

export default CommanForm;

